export default {
  zh: {
    notLogin: '请登录再进行游戏',
    notGame: '没有这个游戏',
    noJs: '请打开Javascript支持',
    notNetwork: '您没有连接网络',
    tokenErr: '账号在其他地方登录或者被封禁，您的游戏进度不会被保存',
    back: '退出',
    haveGold: '您有AAA金币',
    noExchange: '请注意，金币可以变为游戏币，但游戏币不能变为金币',
    cancel: '取消',
    submit: '兑换',
    restart: '兑换以后，游戏将会马上自动重启',
    weekRank: '月排行榜',
    wealthRank: '财富榜',
    scoreRank: '积分榜',
    reward: "奖励",
    noreward: "这个游戏没有竞赛奖励",
    rewardR: "奖励根据积分排行榜",
    carromScoreRule: "积分等于用户获得的游戏币，排除充值",
    noMoney: "没有足够金币，充值吗?",
    Cancel: "取消",
    OK: "确定",
    youGet: "您获得了AAA金币",
    Winner: "获奖用户",
    NoWinner: "没有获奖用户",
    Record: "记录",
    Round: "回合",
    WinningFruit: "中奖水果",
    YourSeleted: "选择的水果",
    Bet: "押注",
    Win: "赢得",
    Rule: "游戏规则",
    RuleDetail: "1.先选择你想押注的水果，然后点击下方的金币按钮增加押注金币；<br/>2.每一轮你可押注最多6种水果，每种水果的押注金额没有上限；<br/>    3.每一轮你有30秒的时间进行押注，然后会进行一次水果抽奖；<br/>4.如果你在抽中的水果上押注了金币，你会得到对应的奖励;<br/> 5.Fruit gifts will not effect in levels and cannot give gem",
    maxFruit: "一次不能超过6个水果",
    maxGold: "一次不能超过100k金币",
    rankList: "排行榜",
    slowNetwork: "网络缓慢，请稍后在历史记录查看",

    won: "赢得了"
  },
  en: {
    notLogin: 'Please log in to play the game',
    notGame: 'no this game',
    noJs: 'Please enable Javascript in your browser to play Game!',
    notNetwork: 'No network',
    tokenErr: 'Account is logged in elsewhere or banned, your game progress will not be saved',
    back: 'Exit',
    haveGold: 'you have AAA gold coins',
    noExchange: 'Note that gold coins can be turned into game coins, but game coins cannot be turned into gold coins',
    cancel: 'Cancel',
    submit: 'Exchange',
    restart: 'The game will restart after exchange',
    weekRank: 'Monthly Rank',
    wealthRank: 'Wealth',
    scoreRank: 'Score',
    reward: "Reward",
    noreward: "There are no rewards in this game",
    rewardR: "Rewards are based on the score rank",
    carromScoreRule: "The score are according to the game coins, excluding excharge",
    noMoney: "Don't have enough gold coins, recharge?",
    Cancel: "Cancel",
    OK: "OK",
    youGet: "You got AAA coins",
    Winner: "Winner",
    NoWinner: "no winner",
    Record: "Record",
    Round: "Round",
    WinningFruit: "winning fruit:",
    YourSeleted: "Your seleted",
    Bet: "Bet",
    Win: "Win",
    Rule: "Rule",
    RuleDetail: "1.First select the fruit you want to bet on, then click the gold button below to increase the bet gold.<br/>2.You can bet on up to 6 kinds of fruits in each round and the bet amount for each fruit is not above limit.<br/> 3.Each round you have 30 seconds to bet, and then there will be a fruit draw prize.<br/>4.If you bet gold coins on the drawn fruit you will get the corresponding reward.<br/>5.Fruit gifts will not effect in levels and cannot give gem.",
    maxFruit: "No more than 6 fruits at a time",
    maxGold: "No more than 100k gold coins at a time",
    rankList: "Rank",
    slowNetwork: "The network is slow, please check the history later",

    won: "won"
  },
  ar: {
    notLogin: 'الرجاء تسجيل الدخول للعب اللعبة',
    notGame: 'لا هذه اللعبة',
    noJs: 'الرجاء تمكين Javascript في متصفحك للعب اللعبة!',
    notNetwork: 'بدون شبكة',
    tokenErr: 'تم تسجيل الدخول إلى الحساب في مكان آخر أو تم حظره ، ولن يتم حفظ تقدم اللعبة',
    back: 'مخرج',
    haveGold: 'لديك عملات ذهبية AAA',
    noExchange: 'لاحظ أنه يمكن تحويل العملات الذهبية إلى عملات معدنية للعبة ، لكن لا يمكن تحويل عملات اللعبة إلى عملات ذهبية',
    cancel: 'يلغي',
    submit: 'تبادل',
    restart: 'ستتم إعادة تشغيل اللعبة بعد التبادل',
    weekRank: 'الترتيب الشهري',
    wealthRank: 'رتبة الثروة',
    scoreRank: 'رتبة النتيجة',
    reward: "جائزة",
    noreward: "لا توجد مكافآت في هذه اللعبة",
    rewardR: "تعتمد المكافآت على تصنيف النقاط",
    carromScoreRule: "النتيجة وفقا لعملات اللعبة ، باستثناء الشحن",
    noMoney: "ليس لديك ما يكفي من العملات الذهبية ، قم بشحنها؟",
    Cancel: "إلغاء",
    OK: "تم",
    youGet: "لقد حصلت على عملات AAA",
    Winner: "الفائز",
    NoWinner: "لا فائز",
    Record: "تسجيل",
    Round: "جولة",
    WinningFruit: "الفوز بالفاكهة",
    YourSeleted: "المحدد الخاص بك",
    Bet: "رهان",
    Win: "فوز",
    Rule: "القواعد",
    RuleDetail: "1.حدد أولاً الفاكهة التي تريد المراهنة عليها، ثم انقر على الزر الذهبي أدناه لزيادة الرهان الذهبي.<br/>2. يمكنك المراهنة على ما يصل إلى 6 أنواع من الفواكه في كل جولة، ولا يتجاوز مبلغ الرهان لكل فاكهة الحد الأقصى.<br/>3. لديك 30 ثانية في كل جولة للمراهنة، وبعد ذلك ستكون هناك جائزة سحب الفاكهة.<br/>4.إذا راهنت بعملات ذهبية على الفاكهة المسحوبة، فسوف تحصل على المكافأة المقابلة.<br/>5. لن تؤثر هدايا الفاكهة في المستويات ولا تعطي كريستال.",
    maxFruit: "ما لا يزيد عن 6 فواكه في المرة الواحدة",
    maxGold: "ما لا يزيد عن 100000 قطعة ذهبية في وقت واحد",
    rankList: "التصنيف",
    slowNetwork: "الشبكة ببطء ، يرجى الاطلاع عليها في السجل لاحقًا",

    won: "won"
  },
  tr: {
    notLogin: 'Oyunu oynamak için lütfen giriş yapın',
    notGame: 'hayır bu oyun',
    noJs: 'Oyun oynamak için lütfen tarayıcınızda Javascript\'i etkinleştirin!',
    notNetwork: 'Ağ yok',
    tokenErr: 'Hesap başka bir yerde oturum açtıysa veya yasaklandı, oyundaki ilerlemeniz kaydedilmeyecek',
    back: 'çıkış',
    haveGold: 'AAA altın paranız var',
    noExchange: 'Altın paraların oyun parasına dönüştürülebileceğini, ancak oyun paralarının altın paraya dönüştürülemeyeceğini unutmayın.',
    cancel: 'İptal',
    submit: 'Değiş tokuş',
    restart: 'Değişimden sonra oyun yeniden başlayacak',
    weekRank: 'الترتيب الشهري',
    wealthRank: 'zenginlik sıralaması',
    scoreRank: 'puan sıralaması',
    reward: "Ödül",
    noreward: "Bu oyunda ödül yok",
    rewardR: "Ödüller puan sıralamasına göre belirlenir",
    carromScoreRule: "Skor, boşaltma hariç oyun jetonlarına göredir.",
    noMoney: "Yeterli altın paranız yok mu?",
    Cancel: "İptal",
    OK: "Tamam",
    youGet: "AAA paran var",
    Winner: "kazanan",
    NoWinner: "kazanan yok",
    Record: "Kayıt",
    Round: "Yuvarlak",
    WinningFruit: "kazanan meyve:",
    YourSeleted: "Seçtiğiniz",
    Bet: "Bahis",
    Win: "Kazanç",
    Rule: "Kural",
    RuleDetail: "1. İlk olarak bahis yapmak istediğiniz meyveyi seçin, ardından bahis altını artırmak için aşağıdaki altın düğmeye tıklayın.<br/>2. Her turda en fazla 6 çeşit meyve üzerine bahis oynayabilirsiniz ve her meyve için bahis miktarı limitin üzerinde değildir.<br/>3. Her turda bahis oynamak için 30 saniyeniz vardır ve ardından bir meyve çekilişi ödülü olacaktır.<br/>4. Eğer çekilen meyveye altın yatırırsanız, karşılık gelen ödülü alırsınız.<br/>5. Meyve hediyeleri seviyeleri etkilemez ve elmas vermez.",
    maxFruit: "Bir seferde en fazla 6 meyve",
    maxGold: "Bir seferde en fazla 100000 altın",
    rankList: "Rütbe",
    slowNetwork: "ağ yavaş, lütfen daha sonra tarihe bakın",

    won: "won"
  },
  pt:{
    notLogin: 'Por favor, faça login para jogar o jogo',
    notGame: 'este jogo não existe',
    noJs: 'Por favor, ative o Javascript no seu navegador para jogar!',
    notNetwork: 'Sem rede',
    tokenErr: 'A conta está logada em outro lugar ou banida, o seu progresso no jogo não será salvo',
    back: 'Sair',
    haveGold: 'Você tem AAA moedas de ouro',
    noExchange: 'Note que as moedas de ouro podem ser convertidas em moedas do jogo, mas as moedas do jogo não podem ser convertidas em moedas de ouro',
    cancel: 'Cancelar',
    submit: 'Trocar',
    restart: 'O jogo será reiniciado após a troca',
    weekRank: 'Ranking Mensal',
    wealthRank: 'Riqueza',
    scoreRank: 'Pontuação',
    reward: "Recompensa",
    noreward: "Não há recompensas neste jogo",
    rewardR: "As recompensas são baseadas no ranking de pontos",
    carromScoreRule: "A pontuação é baseada nas moedas do jogo, excluindo a troca",
    noMoney: "Você não tem moedas de ouro suficientes, deseja recarregar?",
    Cancel: "Cancelar",
    OK: "OK",
    youGet: "Você ganhou AAA moedas",
    Winner: "Vencedor",
    NoWinner: "Sem vencedor",
    Record: "Registro",
    Round: "Rodada",
    WinningFruit: "fruta vencedora:",
    YourSeleted: "Sua seleção",
    Bet: "Aposta",
    Win: "Ganhar",
    Rule: "Regra",
    RuleDetail: "1. Primeiro, selecione a fruta na qual deseja apostar e depois clique no botão de ouro abaixo para aumentar o valor da aposta.<br/>2. Você pode apostar em até 6 tipos de frutas por rodada e o valor da aposta para cada fruta não pode exceder o limite.<br/>3. Cada rodada, você tem 30 segundos para apostar, e depois haverá um sorteio da fruta premiada.<br/>4. Se você apostar moedas de ouro na fruta sorteada, receberá a recompensa correspondente.<br/>5. Os presentes das frutas não afetam os níveis e não podem dar gemas.",
    maxFruit: "Não mais que 6 frutas por vez",
    maxGold: "Não mais que 100k moedas de ouro por vez",
    rankList: "Ranking",
    slowNetwork: "A rede está lenta, por favor, verifique o histórico mais tarde",
    won: "ganhou"

  },
  id:{
    notLogin: 'Silakan masuk untuk memainkan permainan',
    notGame: 'permainan ini tidak ada',
    noJs: 'Harap aktifkan Javascript di browser Anda untuk memainkan permainan!',
    notNetwork: 'Tidak ada jaringan',
    tokenErr: 'Akun sudah login di tempat lain atau diblokir, kemajuan permainan Anda tidak akan disimpan',
    back: 'Keluar',
    haveGold: 'Anda memiliki AAA koin emas',
    noExchange: 'Perlu dicatat bahwa koin emas dapat diubah menjadi koin permainan, tetapi koin permainan tidak dapat diubah menjadi koin emas',
    cancel: 'Batal',
    submit: 'Tukar',
    restart: 'Permainan akan dimulai ulang setelah pertukaran',
    weekRank: 'Peringkat Bulanan',
    wealthRank: 'Kekayaan',
    scoreRank: 'Skor',
    reward: "Hadiah",
    noreward: "Tidak ada hadiah dalam permainan ini",
    rewardR: "Hadiah berdasarkan peringkat skor",
    carromScoreRule: "Skor berdasarkan koin permainan, tidak termasuk pertukaran",
    noMoney: "Tidak memiliki cukup koin emas, isi ulang?",
    Cancel: "Batal",
    OK: "OK",
    youGet: "Anda mendapat AAA koin",
    Winner: "Pemenang",
    NoWinner: "tidak ada pemenang",
    Record: "Rekaman",
    Round: "Putaran",
    WinningFruit: "buah pemenang:",
    YourSeleted: "Pilihan Anda",
    Bet: "Taruhan",
    Win: "Menang",
    Rule: "Aturan",
    RuleDetail: "1. Pertama pilih buah yang ingin Anda pertaruhkan, kemudian klik tombol emas di bawah untuk menambah taruhan emas.<br/>2. Anda dapat bertaruh hingga 6 jenis buah di setiap putaran dan jumlah taruhan untuk setiap buah tidak melebihi batas.<br/> 3. Setiap putaran Anda memiliki 30 detik untuk bertaruh, kemudian akan ada undian hadiah buah.<br/>4. Jika Anda bertaruh koin emas pada buah yang terundi, Anda akan mendapatkan hadiah yang sesuai.<br/>5. Hadiah buah tidak memengaruhi level dan tidak dapat memberikan permata.",
    maxFruit: "Tidak lebih dari 6 buah dalam satu waktu",
    maxGold: "Tidak lebih dari 100k koin emas dalam satu waktu",
    rankList: "Peringkat",
    slowNetwork: "Jaringan lambat, harap periksa riwayat nanti",
    won: "menang"

  },
  uz:{
    "notLogin": "O'yinni o'ynash uchun iltimos, tizimga kiring",
    "notGame": "Bu o'yin mavjud emas",
    "noJs": "O'yinni o'ynash uchun brauzeringizda Javascript-ni yoqing!",
    "notNetwork": "Tarmoq yo'q",
    "tokenErr": "Hisob boshqa joyda kirilgan yoki taqiqlangan, o'yin natijalaringiz saqlanmaydi",
    "back": "Chiqish",
    "haveGold": "Sizda AAA oltin tangalar mavjud",
    "noExchange": "Diqqat, oltin tangalar o'yin tangalariga aylantirilishi mumkin, ammo o'yin tangalari oltin tangalarga aylantirilmaydi",
    "cancel": "Bekor qilish",
    "submit": "Aylantirish",
    "restart": "Aylantirishdan so'ng o'yin qayta ishga tushadi",
    "weekRank": "Oylik reyting",
    "wealthRank": "Boylik",
    "scoreRank": "Ball",
    "reward": "Mukofot",
    "noreward": "Bu o'yinda mukofotlar yo'q",
    "rewardR": "Mukofotlar ball reytingiga asoslanadi",
    "carromScoreRule": "Ballar o'yin tangalariga asoslangan, ayirboshlashni hisobga olmaydi",
    "noMoney": "Yeterli oltin tangalar yo'q, zaryad qilishni xohlaysizmi?",
    "Cancel": "Bekor qilish",
    "OK": "OK",
    "youGet": "Siz AAA tangalar oldingiz",
    "Winner": "G'olib",
    "NoWinner": "G'olib yo'q",
    "Record": "Yozuv",
    "Round": "Davra",
    "WinningFruit": "G'olib bo'lgan meva:",
    "YourSeleted": "Siz tanlagansiz",
    "Bet": "Uynash",
    "Win": "Yutish",
    "Rule": "Qoidalar",
    "RuleDetail": "1. Dastlab, uynash uchun meva tanlang, keyin pastdagi oltin tugmasini bosib, uynash oltinini oshiring.<br/>2. Har bir davrada siz maksimal 6 ta meva tanlashingiz mumkin va har bir mevaga tikish miqdori chegaradan oshmasligi kerak.<br/>3. Har bir davrada tikish uchun 30 soniya bor, keyin meva tortish jarayoni boshlanadi.<br/>4. Agar siz tortilgan mevaga oltin tanga tikgan bo'lsangiz, mos mukofotni olasiz.<br/>5. Meva sovg'alar darajaga ta'sir qilmaydi va marvarid berilmaydi.",
    "maxFruit": "Bir vaqtda 6 dan ortiq meva yo'q",
    "maxGold": "Bir vaqtda 100k oltin tanga yo'q",
    "rankList": "Reyting",
    "slowNetwork": "Tarmoq sekin, iltimos, tarixni keyinroq tekshirib ko'ring",
    "won": "yutdi"
},
    ru:{
    "notLogin": "Пожалуйста, войдите, чтобы играть в игру",
    "notGame": "Эта игра недоступна",
    "noJs": "Пожалуйста, включите Javascript в вашем браузере, чтобы играть в игру!",
    "notNetwork": "Нет сети",
    "tokenErr": "Аккаунт был залогинен в другом месте или заблокирован, ваш прогресс в игре не будет сохранен",
    "back": "Выход",
    "haveGold": "У вас есть AAA золотых монет",
    "noExchange": "Обратите внимание, что золотые монеты можно обменять на игровые монеты, но игровые монеты нельзя обменять на золотые монеты",
    "cancel": "Отмена",
    "submit": "Обменять",
    "restart": "Игра перезапустится после обмена",
    "weekRank": "Ежемесячный рейтинг",
    "wealthRank": "Богатство",
    "scoreRank": "Рейтинг баллов",
    "reward": "Награда",
    "noreward": "В этой игре нет наград",
    "rewardR": "Награды зависят от рейтинга по баллам",
    "carromScoreRule": "Баллы начисляются на основе игровых монет, за исключением обмена",
    "noMoney": "Недостаточно золотых монет, пополнить счет?",
    "Cancel": "Отмена",
    "OK": "OK",
    "youGet": "Вы получили AAA монет",
    "Winner": "Победитель",
    "NoWinner": "Нет победителя",
    "Record": "Запись",
    "Round": "Раунд",
    "WinningFruit": "Выигравший фрукт:",
    "YourSeleted": "Вы выбрали",
    "Bet": "Ставка",
    "Win": "Выигрыш",
    "Rule": "Правила",
    "RuleDetail": "1. Сначала выберите фрукт, на который хотите поставить, затем нажмите на золотую кнопку ниже, чтобы увеличить ставку.<br/>2. В каждом раунде можно поставить на максимум 6 фруктов, при этом сумма ставки на каждый фрукт не должна превышать лимит.<br/>3. У вас есть 30 секунд на ставку, после чего будет проведен розыгрыш фрукта.<br/>4. Если вы поставили золотые монеты на выпавший фрукт, вы получите соответствующую награду.<br/>5. Подарки фрукты не влияют на уровни и не могут давать драгоценности.",
    "maxFruit": "Не более 6 фруктов за раз",
    "maxGold": "Не более 100k золотых монет за раз",
    "rankList": "Рейтинг",
    "slowNetwork": "Сеть медленная, пожалуйста, проверьте историю позже",
    "won": "выиграл"
},
    fa:{
    "notLogin": "لطفاً برای بازی وارد شوید",
    "notGame": "این بازی موجود نیست",
    "noJs": "لطفاً جاوا اسکریپت را در مرورگر خود فعال کنید تا بازی را اجرا کنید!",
    "notNetwork": "شبکه وجود ندارد",
    "tokenErr": "حساب در جای دیگری وارد شده یا مسدود شده است، پیشرفت بازی شما ذخیره نخواهد شد",
    "back": "خروج",
    "haveGold": "شما AAA سکه طلا دارید",
    "noExchange": "توجه داشته باشید که سکه‌های طلا را می‌توان به سکه‌های بازی تبدیل کرد، اما سکه‌های بازی نمی‌توانند به سکه‌های طلا تبدیل شوند",
    "cancel": "لغو",
    "submit": "تبادل",
    "restart": "بازی بعد از تبادل مجدداً راه‌اندازی خواهد شد",
    "weekRank": "رتبه ماهیانه",
    "wealthRank": "ثروت",
    "scoreRank": "رتبه امتیاز",
    "reward": "پاداش",
    "noreward": "در این بازی پاداشی وجود ندارد",
    "rewardR": "پاداش‌ها بر اساس رتبه امتیاز است",
    "carromScoreRule": "امتیازات بر اساس سکه‌های بازی هستند، بدون در نظر گرفتن تبادل",
    "noMoney": "سکه‌های طلا کافی نیست، شارژ کنید؟",
    "Cancel": "لغو",
    "OK": "باشه",
    "youGet": "شما AAA سکه دریافت کردید",
    "Winner": "برنده",
    "NoWinner": "هیچ برنده‌ای وجود ندارد",
    "Record": "ثبت",
    "Round": "دور",
    "WinningFruit": "میوه برنده:",
    "YourSeleted": "شما انتخاب کرده‌اید",
    "Bet": "شرط",
    "Win": "بردن",
    "Rule": "قوانین",
    "RuleDetail": "1. ابتدا میوه‌ای که می‌خواهید شرط بندی کنید را انتخاب کنید، سپس روی دکمه طلا پایین کلیک کنید تا مبلغ شرط خود را افزایش دهید.<br/>2. شما می‌توانید در هر دور تا 6 نوع میوه شرط بندی کنید و مبلغ شرط هر میوه نباید از حد مجاز بیشتر باشد.<br/>3. در هر دور 30 ثانیه برای شرط بندی دارید، سپس قرعه کشی میوه انجام خواهد شد.<br/>4. اگر بر روی میوه قرعه کشی شده سکه طلا شرط بندی کرده باشید، پاداش مربوطه را دریافت خواهید کرد.<br/>5. هدیه‌های میوه‌ای بر روی سطوح تأثیری ندارند و نمی‌توانند جواهر بدهند.",
    "maxFruit": "بیشتر از 6 میوه در یک بار مجاز نیست",
    "maxGold": "بیشتر از 100k سکه طلا در یک بار مجاز نیست",
    "rankList": "رتبه‌بندی",
    "slowNetwork": "شبکه کند است، لطفاً تاریخچه را بعداً بررسی کنید",
    "won": "برنده شد"
}





}


// WEBPACK FOOTER //
// src/pages/activity/fruit1103/lang.js